import React from 'react'
import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {

    render() {
        const { changeHandler, saveHandler, Model, ShowModal, cancelHandler, errors, Mode } = this.props

        return (

            <div class="mb-10">

                <Modal show={ShowModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-3">
                            <label for="name" class="form-label formInput">Nama *</label>
                            <input type="name" class="form-control" id="name" value={Model.name} onChange={changeHandler("name")}></input>
                            <span className="error">{errors["name"]}</span>
                            <span className="error">{errors["name_existed"]}</span>


                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Submit</button>
                        <button type="button" class="btn btn-primary" onClick={cancelHandler}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
